import { React, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
//import { MDXEditor, headingsPlugin, listsPlugin, thematicBreakPlugin, UndoRedo, BoldItalicUnderlineToggles, toolbarPlugin, BlockTypeSelect, tablePlugin, InsertTable } from '@mdxeditor/editor'
//import "@mdxeditor/editor/style.css";
import { BookOpenIcon, EnvelopeIcon, InboxStackIcon, PencilSquareIcon } from "@heroicons/react/20/solid";
import { Actions as PENSIONACTIONS } from "@/redux/actions/pensionActions";
import { v4 as uuidv4 } from "uuid";
import PensionAuditLogs from "./audit-logs/PensionAuditLogs";
import { MentionsInput, Mention } from "react-mentions";
import MentionInputStyle from "@/components/report/MentionInputStyle";
import DocumentTable from "@/components/documents/DocumentTable";
import Select from "react-select";

const mentionStyle = {
	backgroundColor: "rgb(255, 222, 205)",
	borderRadius: "5px",
	padding: 3,
	marginLeft: -3,
	marginRight: -3,
	fontSize: "13px",
	// lineHeight: "18px",
	// fontWeight: "bold",
	// color: "white"
};
const autoEnrolmentLetters = [
	{
		value: "ukAutoEnrolmentEnrolled",
		label: "Enrolled",
	},
	{
		value: "ukAutoEnrolmentNotAutoEnrolled",
		label: "Not Enrolled",
	},
	{
		value: "ukAutoEnrolmentPostponement",
		label: "Postponement",
	},
	{
		value: "ukAutoEnrolmentFAQ",
		label: "Workplace Pension FAQ",
	},
	{
		value: "enrollmentNoTaxRelief",
		label: "Enrollment No Tax Relief",
	},
];

const Letters = ({ saveLetter, getLetter, letter, getAuditLogs, auditLogs }) => {
	// const editorRef = useRef(null)

	const [markdown, setMarkdown] = useState("");
	const [key, setKey] = useState("ukAutoEnrolmentEnrolled");
	const [auditLogVisibility, setAuditLogVisibility] = useState(false);
	const [showGeneratedLetters, setShowGeneratedLetters] = useState(true);
	const [showEditTemplates, setShowEditTemplates] = useState(false);

	useEffect(() => {
		// editorRef.current?.setMarkdown(letter?.letter ?? "");
		setMarkdown(letter?.letter ?? "");
	}, [letter]);

	useEffect(() => {
		getLetter(key);

		// turn off audit logs when switching letters
		if (auditLogVisibility) {
			setAuditLogVisibility(false);
		}
	}, [key]);

	return (
		<>
			<div className="content">
				<div className="row">
					<div className="col-xs-12 p-0">
						<div class="pull-left">
							<h5>Letters</h5>
						</div>
						<div className="pull-right">
							<div
								className={`btn btn-${showEditTemplates ? "default" : "primary"}`}
								onClick={() => {
									setShowEditTemplates(true);
									setShowGeneratedLetters(false);
								}}
								style={{
									borderRadius: "8px 0px 0px 8px",
									cursor: showEditTemplates ? "default" : "pointer",
									pointerEvents: showEditTemplates ? "none" : "auto",
								}}
							>
								<PencilSquareIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								Edit Templates
							</div>

							<div
								className={`btn btn-${showGeneratedLetters ? "default" : "primary"}`}
								onClick={() => {
									setShowGeneratedLetters(true);
									setShowEditTemplates(false);
								}}
								style={{
									borderRadius: "0px 8px 8px 0px",
									cursor: showGeneratedLetters ? "default" : "pointer",
									pointerEvents: showGeneratedLetters ? "none" : "auto",
								}}
							>
								<InboxStackIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								Generated Letters
							</div>
						</div>
					</div>

					<div style={{ marginBottom: "5.5em", display: `${showGeneratedLetters ? "block" : "none"}` }}>
						<DocumentTable type="Auto Enrolment" />
					</div>

					<div style={{ marginBottom: "5.5em", display: `${showEditTemplates ? "block" : "none"}` }}>
						<div
							className="col-xs-12 p-0 mb-5"
							style={{ display: "flex", gap: "10px" }}
						>
							<div className="col-xs-3 p-0">
								<label>Letter Template</label>
								<Select
									options={autoEnrolmentLetters}
									value={autoEnrolmentLetters.find((letter) => letter.value === key)}
									onChange={(e) => {
										setKey(e?.value);
									}}
								/>
							</div>
							<div className="col-xs-3 p-0 pull-left mt-10">
								<div
									className="btn btn-default"
									onClick={() => {
										if (letter?.id) {
											!auditLogVisibility && getAuditLogs(letter?.id);
											console.debug("auditlogs:", auditLogs);
											setAuditLogVisibility(!auditLogVisibility);
										}
									}}
									disabled={!letter?.id}
								>
									<BookOpenIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<div style={{ float: "left" }}>
										{auditLogVisibility ? "Hide Template History" : "Show Template History"}
									</div>
								</div>
							</div>
							{!auditLogVisibility && (
								<div className="col-xs-1 p-0 pull-right mt-10">
									<div
										className="btn btn-success pull-right"
										onClick={() => {
											saveLetter({ key: key, letter: markdown, id: letter?.id });
										}}
									>
										<EnvelopeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Save</div>
									</div>
								</div>
							)}
						</div>
						{auditLogVisibility && <PensionAuditLogs />}
						<div
							style={{
								border: "1px solid #ccc",
								borderRadius: "4px",
								padding: "10px",
								marginTop: "10px",
								marginBottom: "10px",
								minHeight: "200px",
								overflow: "auto",
								lineHeight: "18px",
								fontSize: "13px",
								display: `${auditLogVisibility ? "none" : "block"}`,
							}}
						>
							<MentionsInput
								markup="@[__display__]"
								value={markdown}
								onChange={(event) => {
									setMarkdown(event.target.value);
								}}
								style={{
									...MentionInputStyle,
								}}
							>
								<Mention
									trigger="@"
									data={[
										{ id: "employer", display: "Employer" },
										{ id: "employeeGivenName", display: "Employee First Name" },
										{ id: "employeeFamilyName", display: "Employee Last Name" },
										{ id: "employeeFullName", display: "Employee Full Name" },
										{ id: "pensionPostponementDate", display: "Postponement Until Date" },
										{ id: "pensionWeeklyMinimum", display: "Weekly Auto Enrolment Minimum" },
										{ id: "pensionMonthlyMinimum", display: "Monthly Auto Enrolment Minimum" },
										{ id: "pensionMinimumAge", display: "Minimum Auto Enrolment Age" },
									]}
									style={mentionStyle}
									singleLine={false}
								/>
							</MentionsInput>
						</div>
					</div>

					{/*<MDXEditor ref={editorRef} markdown={""} onChange={(newMarkdown) => setMarkdown(newMarkdown)}
                plugins={[
                    headingsPlugin(),
                    listsPlugin(),
                    thematicBreakPlugin(),
                    tablePlugin(),
                    toolbarPlugin({
                        toolbarContents: () => (
                            <>
                                {' '}
                                <UndoRedo />
                                <BoldItalicUnderlineToggles />
                                <BlockTypeSelect />
                                <InsertTable />
                            </>
                        )
                    })
                ]}
            />*/}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const letter = state?.pensions?.letter;
	return {
		letter: state?.pensions?.letter,
		auditLogs: state?.pensions?.auditLogs,
	};
};

const mapDispatchToProps = (dispatch) => ({
	saveLetter: ({ key, letter, id }) => dispatch(PENSIONACTIONS.saveLetter({ key, letter, id })),
	getLetter: (key) => dispatch(PENSIONACTIONS.getLetter(key)),
	getAuditLogs: (id) => dispatch(PENSIONACTIONS.getAuditLogs(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Letters);
